/* eslint-disable max-classes-per-file */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    // manual close buttons
    this.closeButton = this.querySelector('button.close');
    if (this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));
  }

  onFocusOut() {
    // this.mainDetailsToggle.classList.add('closing');
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
      // this.mainDetailsToggle.classList.remove('closing');
    }, 0);
  }

  onToggle() {
    // in theory this fires and can be used to watch the close event
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      // this.animations.forEach((animation) => animation.play());
    } else {
      this.mainDetailsToggle.classList.add('closing');
      // this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.classList.toggle('menu-open');
    this.header.preventHide = this.mainDetailsToggle.open;
  }
}

customElements.define('header-menu', HeaderMenu);
